import type { HomeTryon } from './HomeScreen';

export function sortHomeTryonsNewestFirst(tryons: HomeTryon[]): HomeTryon[] {
  return [...tryons].sort((left, right) => right.createdAt - left.createdAt || right.id.localeCompare(left.id));
}
